import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, vModelSelect as _vModelSelect, vModelText as _vModelText } from "vue";
import _imports_0 from './../../assets/image/qcpay/pc/alipay.png';
import _imports_1 from './../../assets/image/qcpay/pc/wechat.png';
import _imports_2 from './../../assets/image/qcpay/pc/pay-other.png';
import _imports_3 from './../../assets/image/qcpay/close.png';
import _imports_4 from './../../assets/image/qcpay/apple.png';
import _imports_5 from './../../assets/image/qcpay/andriod.png';
const _hoisted_1 = {
  class: "pay-container"
};
const _hoisted_2 = {
  key: 0,
  class: "top-banner"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  class: "pay-list-container"
};
const _hoisted_5 = {
  class: "top-list"
};
const _hoisted_6 = {
  class: "top-list-left"
};
const _hoisted_7 = ["onClick"];
const _hoisted_8 = ["src"];
const _hoisted_9 = {
  class: "choice-game more-btn-container"
};
const _hoisted_10 = {
  class: "more-btn"
};
const _hoisted_11 = {
  class: "pc-top-list-info"
};
const _hoisted_12 = {
  class: "pc-top-info-container"
};
const _hoisted_13 = {
  class: "right-title"
};
const _hoisted_14 = {
  class: "pc-my-points"
};
const _hoisted_15 = {
  class: "pc-choice-tip-container"
};
const _hoisted_16 = {
  class: "top-list-m"
};
const _hoisted_17 = {
  class: "top-img"
};
const _hoisted_18 = ["src"];
const _hoisted_19 = {
  class: "game-icon-body"
};
const _hoisted_20 = {
  class: "game-list"
};
const _hoisted_21 = ["onClick"];
const _hoisted_22 = ["src"];
const _hoisted_23 = {
  key: 1,
  class: "login-h5-mid-container"
};
const _hoisted_24 = {
  class: "login-list-container-sec"
};
const _hoisted_25 = {
  class: "login-list-container-sec bot-sec-longin"
};
const _hoisted_26 = {
  class: "choice-btn-title"
};
const _hoisted_27 = {
  key: 0,
  class: "pay-list-body"
};
const _hoisted_28 = {
  class: "pay-container-bot"
};
const _hoisted_29 = {
  class: "pay-container-left-container"
};
const _hoisted_30 = {
  class: "pay-left-container"
};
const _hoisted_31 = {
  class: "left-line pc-left-line"
};
const _hoisted_32 = {
  class: "left-title"
};
const _hoisted_33 = {
  class: "pay-page"
};
const _hoisted_34 = ["onClick"];
const _hoisted_35 = {
  class: "pay-list-left"
};
const _hoisted_36 = {
  key: 0
};
const _hoisted_37 = {
  class: "left-line"
};
const _hoisted_38 = {
  class: "left-title"
};
const _hoisted_39 = {
  class: "pay-page"
};
const _hoisted_40 = ["onClick"];
const _hoisted_41 = ["src"];
const _hoisted_42 = {
  class: "pack-img"
};
const _hoisted_43 = {
  key: 0,
  class: "sale-img"
};
const _hoisted_44 = {
  key: 0,
  class: "tips-title"
};
const _hoisted_45 = {
  key: 0
};
const _hoisted_46 = {
  key: 1
};
const _hoisted_47 = {
  key: 2
};
const _hoisted_48 = {
  key: 1,
  class: "tips-title"
};
const _hoisted_49 = {
  key: 2,
  class: "tips-title"
};
const _hoisted_50 = {
  key: 0
};
const _hoisted_51 = {
  key: 1
};
const _hoisted_52 = ["src"];
const _hoisted_53 = {
  class: "pack-title"
};
const _hoisted_54 = {
  class: "pack-price"
};
const _hoisted_55 = {
  key: 1,
  class: "pc-recharge"
};
const _hoisted_56 = {
  class: "pc-pay-left-container"
};
const _hoisted_57 = {
  class: "recharge-container"
};
const _hoisted_58 = {
  class: "recharge-block-container"
};
const _hoisted_59 = {
  key: 0,
  class: "top-title"
};
const _hoisted_60 = {
  class: "mid-img"
};
const _hoisted_61 = {
  class: "mid-img-bg"
};
const _hoisted_62 = ["src"];
const _hoisted_63 = {
  key: 0,
  class: "bot-detail van-multi-ellipsis--l2"
};
const _hoisted_64 = {
  key: 1,
  class: "right-icon"
};
const _hoisted_65 = {
  key: 2,
  class: "over-block"
};
const _hoisted_66 = {
  class: "over-bot-title van-multi-ellipsis--l2"
};
const _hoisted_67 = {
  class: "recharge-line-bw"
};
const _hoisted_68 = ["id"];
const _hoisted_69 = {
  key: 0,
  class: "recharge-icon"
};
const _hoisted_70 = {
  key: 1,
  class: "recharge-icon-fir"
};
const _hoisted_71 = {
  key: 2,
  class: "recharge-icon-sec"
};
const _hoisted_72 = {
  key: 0,
  class: "bot-next-tips"
};
const _hoisted_73 = {
  key: 0
};
const _hoisted_74 = {
  key: 1
};
const _hoisted_75 = ["innerHTML"];
const _hoisted_76 = {
  class: "bot-ruler"
};
const _hoisted_77 = ["innerHTML"];
const _hoisted_78 = ["innerHTML"];
const _hoisted_79 = ["innerHTML"];
const _hoisted_80 = ["innerHTML"];
const _hoisted_81 = {
  key: 0,
  class: "h5-other-list-container"
};
const _hoisted_82 = {
  class: "left-line"
};
const _hoisted_83 = {
  class: "left-title"
};
const _hoisted_84 = {
  class: "pay-page"
};
const _hoisted_85 = ["onClick"];
const _hoisted_86 = ["src"];
const _hoisted_87 = {
  key: 0,
  class: "tips-title"
};
const _hoisted_88 = {
  key: 0
};
const _hoisted_89 = {
  key: 1
};
const _hoisted_90 = {
  key: 2
};
const _hoisted_91 = {
  key: 1,
  class: "tips-title"
};
const _hoisted_92 = {
  key: 2,
  class: "tips-title"
};
const _hoisted_93 = {
  key: 0
};
const _hoisted_94 = {
  key: 1
};
const _hoisted_95 = {
  class: "top-pack-img"
};
const _hoisted_96 = {
  key: 0,
  class: "sale-img"
};
const _hoisted_97 = ["src"];
const _hoisted_98 = {
  class: "limited-tips"
};
const _hoisted_99 = {
  key: 0,
  class: "limited-container limited-tips5"
};
const _hoisted_100 = {
  class: "pack-title"
};
const _hoisted_101 = {
  class: "pack-price"
};
const _hoisted_102 = {
  class: "pay-container-right-container"
};
const _hoisted_103 = {
  class: "choice-list-item"
};
const _hoisted_104 = {
  class: "bingding-detail h5-hide-tips"
};
const _hoisted_105 = {
  class: "detail-list"
};
const _hoisted_106 = {
  key: 0,
  class: "detail-right"
};
const _hoisted_107 = {
  key: 1,
  class: "detail-right"
};
const _hoisted_108 = {
  key: 0,
  class: "detail-list"
};
const _hoisted_109 = {
  class: "detail-right"
};
const _hoisted_110 = {
  key: 0,
  class: "detail-right"
};
const _hoisted_111 = {
  key: 1,
  class: "detail-right"
};
const _hoisted_112 = {
  key: 1,
  class: "detail-list none-bot"
};
const _hoisted_113 = {
  class: "detail-right"
};
const _hoisted_114 = {
  key: 0
};
const _hoisted_115 = {
  class: "price"
};
const _hoisted_116 = {
  class: "pay-choice-list h5-pay-choice-list"
};
const _hoisted_117 = {
  class: "pay-bot-btn-web h5-pay-bot-btn-web"
};
const _hoisted_118 = {
  class: "pay-btn"
};
const _hoisted_119 = {
  class: "agreement"
};
const _hoisted_120 = {
  key: 0,
  class: "h5-other-list-container"
};
const _hoisted_121 = {
  class: "recharge-container",
  id: "recharge-block-container-sec"
};
const _hoisted_122 = {
  class: "recharge-block-container"
};
const _hoisted_123 = {
  key: 0,
  class: "top-title"
};
const _hoisted_124 = {
  class: "mid-img"
};
const _hoisted_125 = {
  class: "mid-img-bg"
};
const _hoisted_126 = ["src"];
const _hoisted_127 = {
  key: 0,
  class: "bot-detail van-multi-ellipsis--l2"
};
const _hoisted_128 = {
  key: 1,
  class: "right-icon"
};
const _hoisted_129 = {
  key: 2,
  class: "over-block"
};
const _hoisted_130 = {
  class: "over-bot-title van-multi-ellipsis--l2"
};
const _hoisted_131 = {
  class: "recharge-line-bw"
};
const _hoisted_132 = ["id"];
const _hoisted_133 = {
  key: 0,
  class: "recharge-icon"
};
const _hoisted_134 = {
  key: 1,
  class: "recharge-icon-fir"
};
const _hoisted_135 = {
  key: 2,
  class: "recharge-icon-sec"
};
const _hoisted_136 = {
  key: 0,
  class: "bot-next-tips"
};
const _hoisted_137 = {
  key: 0
};
const _hoisted_138 = {
  key: 1
};
const _hoisted_139 = ["innerHTML"];
const _hoisted_140 = {
  key: 1
};
const _hoisted_141 = {
  key: 2,
  class: "h5-bot-ruler"
};
const _hoisted_142 = ["innerHTML"];
const _hoisted_143 = ["innerHTML"];
const _hoisted_144 = ["innerHTML"];
const _hoisted_145 = ["innerHTML"];
const _hoisted_146 = {
  key: 3,
  class: "h5-pay-bot-btn"
};
const _hoisted_147 = {
  class: "total"
};
const _hoisted_148 = {
  class: "pay-bot-btn"
};
const _hoisted_149 = {
  class: "pay-btn"
};
const _hoisted_150 = {
  class: "agreement"
};
const _hoisted_151 = {
  class: "h5-pay-popup"
};
const _hoisted_152 = {
  class: "title"
};
const _hoisted_153 = {
  class: "choice-store"
};
const _hoisted_154 = {
  class: "bingding-detail"
};
const _hoisted_155 = {
  class: "detail-list"
};
const _hoisted_156 = {
  key: 0,
  class: "detail-right"
};
const _hoisted_157 = {
  key: 1,
  class: "detail-right"
};
const _hoisted_158 = {
  key: 0,
  class: "detail-list"
};
const _hoisted_159 = {
  class: "detail-right"
};
const _hoisted_160 = {
  class: "detail-list"
};
const _hoisted_161 = {
  key: 0,
  class: "detail-right"
};
const _hoisted_162 = {
  key: 1,
  class: "detail-right"
};
const _hoisted_163 = {
  key: 1,
  class: "detail-list"
};
const _hoisted_164 = {
  class: "detail-right"
};
const _hoisted_165 = {
  key: 0
};
const _hoisted_166 = {
  class: "game-detail-container"
};
const _hoisted_167 = {
  class: "bot-total"
};
const _hoisted_168 = {
  class: "pay-choice-list"
};
const _hoisted_169 = {
  key: 0,
  class: "pay-recommend"
};
const _hoisted_170 = {
  class: "pay-bot-btn-web"
};
const _hoisted_171 = {
  class: "pay-btn"
};
const _hoisted_172 = {
  class: "agreement"
};
const _hoisted_173 = {
  class: "game-role-container"
};
const _hoisted_174 = {
  class: "system-list"
};
const _hoisted_175 = {
  key: 0
};
const _hoisted_176 = {
  key: 1,
  class: "andriod-list"
};
const _hoisted_177 = ["value"];
const _hoisted_178 = {
  key: 0,
  class: "last-pay"
};
const _hoisted_179 = {
  class: "btn-list"
};
const _hoisted_180 = {
  class: "qrcode-box"
};
const _hoisted_181 = {
  id: "qrcode",
  class: "qrcode",
  ref: "qrcodes"
};
const _hoisted_182 = {
  class: "login-box"
};
const _hoisted_183 = {
  class: "header-container"
};
const _hoisted_184 = {
  class: "header-btn"
};
const _hoisted_185 = {
  class: "tabs-list-container"
};
const _hoisted_186 = {
  class: "input-container"
};
const _hoisted_187 = {
  class: "input-body"
};
const _hoisted_188 = {
  class: "input-container"
};
const _hoisted_189 = {
  class: "input-body"
};
const _hoisted_190 = {
  class: "login-btn"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_MoreFilled = _resolveComponent("MoreFilled");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_router_link = _resolveComponent("router-link");
  const _component_ArrowRightBold = _resolveComponent("ArrowRightBold");
  const _component_van_button = _resolveComponent("van-button");
  const _component_PointsMallOld = _resolveComponent("PointsMallOld");
  const _component_van_icon = _resolveComponent("van-icon");
  const _component_van_popup = _resolveComponent("van-popup");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [$setup.list.publicity_pc ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("img", {
    src: $setup.list.publicity_pc,
    alt: ""
  }, null, 8, _hoisted_3)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.gameListTop, item => {
    return _openBlock(), _createElementBlock("div", {
      class: "choice-game",
      key: item.game_id,
      onClick: $event => $setup.changeGame(item)
    }, [_createElementVNode("div", {
      class: _normalizeClass([item.game_id == $setup.gameId ? 'ico-img-click' : 'ico-img'])
    }, [_createElementVNode("img", {
      src: item.ico,
      alt: ""
    }, null, 8, _hoisted_8)], 2), _createElementVNode("div", {
      class: _normalizeClass([item.game_id == $setup.gameId ? 'game-title-click' : 'game-title'])
    }, _toDisplayString(item.game_list.name), 3)], 8, _hoisted_7);
  }), 128)), _createVNode(_component_router_link, {
    to: "/home"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createVNode(_component_el_icon, null, {
      default: _withCtx(() => [_createVNode(_component_MoreFilled)]),
      _: 1
    })]), _cache[47] || (_cache[47] = _createElementVNode("div", {
      class: "more-btn-title"
    }, "查看更多游戏", -1))])]),
    _: 1
  })]), _createElementVNode("div", {
    class: "choice-btn",
    onClick: _cache[0] || (_cache[0] = $event => $setup.showGameRole())
  }, [_createElementVNode("div", null, _toDisplayString($setup.chooseGameList.nickname || $setup.chooseGameList.role_name || "角色名称") + "." + _toDisplayString($setup.chooseGameList.dist_name || $setup.chooseGameList.server_name || "游戏区组"), 1), _createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_ArrowRightBold)]),
    _: 1
  })])]), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", {
    class: "choice-btn",
    onClick: _cache[1] || (_cache[1] = $event => $setup.showGameRole())
  }, [_createElementVNode("div", null, _toDisplayString($setup.chooseGameList.nickname || $setup.chooseGameList.role_name || "角色名称") + "." + _toDisplayString($setup.chooseGameList.dist_name || $setup.chooseGameList.server_name || "游戏区组"), 1), _createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_ArrowRightBold)]),
    _: 1
  })]), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_cache[48] || (_cache[48] = _createTextVNode(" 当前积分: ")), _createElementVNode("span", null, _toDisplayString($setup.pointsNum || 0), 1)]), _createElementVNode("span", {
    class: "exchange hover-type",
    onClick: _cache[2] || (_cache[2] = $event => $setup.goExchangePage())
  }, "兑换记录"), _createElementVNode("span", {
    class: "details hover-type",
    onClick: _cache[3] || (_cache[3] = $event => $setup.goPointsDetail())
  }, "积分明细")])])]), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", {
    class: "choice-list-tips",
    onClick: _cache[4] || (_cache[4] = $event => $setup.showCashCoupon = true)
  }, [_cache[49] || (_cache[49] = _createTextVNode(" 游戏充值 ")), _createElementVNode("span", {
    class: _normalizeClass(["bot-line", [$setup.showCashCoupon ? 'long-line-ani' : '']])
  }, null, 2)]), _createElementVNode("div", {
    class: "choice-list-tips",
    onClick: _cache[5] || (_cache[5] = $event => $setup.goJfMallPage())
  }, [_cache[50] || (_cache[50] = _createTextVNode(" 积分商城 ")), _createElementVNode("span", {
    class: _normalizeClass(["bot-line", [!$setup.showCashCoupon ? 'long-line-ani' : '']])
  }, null, 2)])]), _createElementVNode("div", _hoisted_16, [_withDirectives(_createElementVNode("div", _hoisted_17, [_createElementVNode("img", {
    src: $setup.list.publicity_wap || $setup.list.publicity_pc,
    alt: ""
  }, null, 8, _hoisted_18)], 512), [[_vShow, $setup.list.publicity_wap || $setup.list.publicity_pc]]), _createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.gameListTop, item => {
    return _openBlock(), _createElementBlock("div", {
      class: "game-icon",
      key: item.game_id,
      onClick: $event => $setup.changeGame(item)
    }, [_createElementVNode("div", {
      class: _normalizeClass([item.game_id == $setup.gameId ? 'game-img-click' : 'game-img'])
    }, [_createElementVNode("img", {
      src: item.ico,
      alt: ""
    }, null, 8, _hoisted_22)], 2), _createElementVNode("div", {
      class: _normalizeClass([item.game_id == $setup.gameId ? 'game-name-click' : 'game-name'])
    }, _toDisplayString(item.game_list.name), 3)], 8, _hoisted_21);
  }), 128))]), $setup.loginType == 1 ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "login-h5-mid-container",
    onClick: _cache[6] || (_cache[6] = $event => $setup.loginBtn())
  }, _cache[51] || (_cache[51] = [_createElementVNode("div", null, "您好，请登录", -1)]))) : (_openBlock(), _createElementBlock("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, [_createElementVNode("div", null, [_createElementVNode("span", null, _toDisplayString($setup.mobile), 1), _createElementVNode("span", {
    class: "small-text",
    onClick: _cache[7] || (_cache[7] = $event => $setup.loginOut())
  }, "注销")]), _createElementVNode("div", null, [_cache[52] || (_cache[52] = _createElementVNode("span", {
    class: "small-text"
  }, "当前积分:", -1)), _createElementVNode("span", null, _toDisplayString($setup.pointsNum || 0), 1)])]), _createElementVNode("div", _hoisted_25, [_createElementVNode("div", {
    class: "choice-btn",
    onClick: _cache[8] || (_cache[8] = $event => $setup.showGameRole())
  }, [_createElementVNode("div", _hoisted_26, _toDisplayString($setup.chooseGameList.nickname || $setup.chooseGameList.role_name || "角色名称") + "." + _toDisplayString($setup.chooseGameList.dist_name || $setup.chooseGameList.server_name || "游戏区组"), 1), _createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_ArrowRightBold)]),
    _: 1
  })]), _createElementVNode("div", null, [_createElementVNode("span", {
    class: "exchange-btn",
    onClick: _cache[9] || (_cache[9] = $event => $setup.goExchangePage())
  }, "兑换记录 "), _createElementVNode("span", {
    class: "points-detail",
    onClick: _cache[10] || (_cache[10] = $event => $setup.goPointsDetail())
  }, "积分明细")])])]))])]), _createElementVNode("div", {
    class: _normalizeClass(["h5-top-choice", [!$setup.mobile ? 'no-login' : '']])
  }, [_createElementVNode("div", {
    class: _normalizeClass(["top-choice", [$setup.showCashCoupon ? 'choice-award' : '']]),
    onClick: _cache[11] || (_cache[11] = $event => $setup.showCashCoupon = true)
  }, [_cache[53] || (_cache[53] = _createTextVNode(" 游戏充值 ")), _createElementVNode("div", {
    class: _normalizeClass(["bot-line", [$setup.showCashCoupon ? 'long-line-ani' : '']])
  }, null, 2)], 2), _createElementVNode("div", {
    class: _normalizeClass(["top-choice", [!$setup.showCashCoupon ? 'choice-award' : '']]),
    onClick: _cache[12] || (_cache[12] = $event => $setup.goJfMallPage())
  }, [_cache[54] || (_cache[54] = _createTextVNode(" 积分商城 ")), _createElementVNode("div", {
    class: _normalizeClass(["bot-line", [!$setup.showCashCoupon ? 'long-line-ani' : '']])
  }, null, 2)], 2)], 2), $setup.showCashCoupon ? (_openBlock(), _createElementBlock("div", _hoisted_27, [_createElementVNode("div", _hoisted_28, [_createElementVNode("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, [_createElementVNode("div", _hoisted_31, [_cache[55] || (_cache[55] = _createElementVNode("span", {
    class: "left-line-bgc"
  }, null, -1)), _createElementVNode("span", _hoisted_32, _toDisplayString($setup.list.goods_alias), 1)]), _createElementVNode("div", _hoisted_33, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.list.product, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "pay-block",
      key: item.id
    }, [_createElementVNode("div", {
      class: _normalizeClass(["pay-list", [$setup.choiceItem.id == item.id ? 'show-border' : '']]),
      onClick: $event => $setup.choicePay(item, index, 1)
    }, [_createElementVNode("div", _hoisted_35, _toDisplayString(item.name), 1)], 10, _hoisted_34)]);
  }), 128))]), $setup.list.category_related_game && $setup.list.category_related_game.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_36, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.list.category_related_game, item => {
    return _openBlock(), _createElementBlock("div", {
      class: "pc-pay-left-container",
      key: item.id
    }, [_createElementVNode("div", _hoisted_37, [_cache[56] || (_cache[56] = _createElementVNode("span", {
      class: "left-line-bgc"
    }, null, -1)), _createElementVNode("span", _hoisted_38, _toDisplayString(item.category_official.name), 1)]), _createElementVNode("div", _hoisted_39, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.game_pay_official_prop, (subItem, subIndex) => {
      return _openBlock(), _createElementBlock("div", {
        class: "pay-block",
        key: subItem.id
      }, [_createElementVNode("div", {
        class: _normalizeClass(["pay-list-pack", [$setup.choiceItem.id == subItem.id ? 'pack-show-border' : '']]),
        onClick: $event => $setup.choicePay(subItem, subIndex, 2)
      }, [subItem.tag_img ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["discount-icon", [subItem.game_stock == subItem.quantity && subItem.quantity >= 0 ? ' sale-out' : '']])
      }, [_createElementVNode("img", {
        src: subItem.tag_img,
        alt: ""
      }, null, 8, _hoisted_41)], 2)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_42, [subItem.game_stock == subItem.quantity && subItem.quantity >= 0 ? (_openBlock(), _createElementBlock("div", _hoisted_43)) : _createCommentVNode("", true), _createElementVNode("div", {
        class: _normalizeClass(["tips-list", [subItem.game_stock == subItem.quantity ? ' sale-out' : '']])
      }, [(subItem.limit_type == 1 || subItem.limit_type == 2 || subItem.limit_type == 3) && subItem.limit_shelve == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_44, [_cache[57] || (_cache[57] = _createTextVNode(" 每")), subItem.limit_type == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_45, "天")) : _createCommentVNode("", true), subItem.limit_type == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_46, "周")) : _createCommentVNode("", true), subItem.limit_type == 3 ? (_openBlock(), _createElementBlock("span", _hoisted_47, "月")) : _createCommentVNode("", true), _createTextVNode("限购" + _toDisplayString(subItem.game_stock) + "/" + _toDisplayString(subItem.quantity), 1)])) : _createCommentVNode("", true), (subItem.limit_type == 1 || subItem.limit_type == 2 || subItem.limit_type == 3) && subItem.limit_shelve > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_48, " 限购" + _toDisplayString(subItem.game_stock) + "/" + _toDisplayString(subItem.quantity), 1)) : _createCommentVNode("", true), subItem.limit_type == 5 ? (_openBlock(), _createElementBlock("div", _hoisted_49, [subItem.is_limited_time != 1 ? (_openBlock(), _createElementBlock("span", _hoisted_50, "永久")) : _createCommentVNode("", true), _cache[58] || (_cache[58] = _createTextVNode("限购")), subItem.quantity > -1 ? (_openBlock(), _createElementBlock("span", _hoisted_51, _toDisplayString(subItem.game_stock) + "/" + _toDisplayString(subItem.quantity), 1)) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _cache[59] || (_cache[59] = _createElementVNode("div", {
        class: "bot-icon"
      }, null, -1))], 2), _createElementVNode("img", {
        class: _normalizeClass([subItem.game_stock == subItem.quantity && subItem.quantity >= 0 ? ' sale-out' : '']),
        src: subItem.image_url,
        alt: ""
      }, null, 10, _hoisted_52), subItem.is_limited_time == 1 ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass(["tips-container tips-container5", [subItem.game_stock == subItem.quantity && subItem.quantity >= 0 ? ' sale-out' : '']])
      }, null, 2)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_53, _toDisplayString(subItem.name), 1), _createElementVNode("div", _hoisted_54, "￥" + _toDisplayString(subItem.price), 1)], 10, _hoisted_40)]);
    }), 128))])]);
  }), 128))])) : _createCommentVNode("", true), $setup.rechargeCategoryList.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_55, [_createElementVNode("div", _hoisted_56, [_cache[64] || (_cache[64] = _createElementVNode("div", {
    class: "left-line"
  }, [_createElementVNode("span", {
    class: "left-line-bgc"
  }), _createElementVNode("span", {
    class: "left-title"
  }, "充值活动")], -1)), _createElementVNode("div", _hoisted_57, [_createElementVNode("div", _hoisted_58, [_createElementVNode("div", {
    class: _normalizeClass(["recharge-list", [$setup.progressWidth == 712 ? 'recharge-list-sec' : '']])
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.rechargeCategoryList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "recharge-block-list",
      key: index
    }, [_createElementVNode("div", {
      class: _normalizeClass([[$setup.rechargePhase == index && !item.is_rewards ? 'recharge-block-sec' : 'recharge-block'], "recharge-public"])
    }, [!item.is_rewards ? (_openBlock(), _createElementBlock("div", _hoisted_59, " 累计" + _toDisplayString(item.price) + "元 ", 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_60, [_createElementVNode("div", _hoisted_61, [_createElementVNode("img", {
      src: item.img || `https://download4.qcplay.com/qcgame-admin/ug1Q1ZRFe6i1Ef7ANtqtB9Bs43HK7cxyITNtUkwH.png`,
      alt: ""
    }, null, 8, _hoisted_62)]), !item.is_rewards ? (_openBlock(), _createElementBlock("div", _hoisted_63, _toDisplayString(item.name), 1)) : _createCommentVNode("", true)]), $setup.rechargePhase == index && !item.is_rewards ? (_openBlock(), _createElementBlock("div", _hoisted_64, " 下阶段 ")) : _createCommentVNode("", true), item.is_rewards ? (_openBlock(), _createElementBlock("div", _hoisted_65, [_cache[60] || (_cache[60] = _createElementVNode("div", {
      class: "over-top-title"
    }, "已获得", -1)), _cache[61] || (_cache[61] = _createElementVNode("div", {
      class: "over-mid-img"
    }, [_createElementVNode("img", {
      src: "https://download4.qcplay.com/qcgame-api/3d7lL3V9x9MrwKANuMbkhzbSrka0rAXC7FU4wOgd.png",
      alt: ""
    })], -1)), _createElementVNode("div", _hoisted_66, _toDisplayString(item.content), 1)])) : _createCommentVNode("", true)], 2)]);
  }), 128))], 2), _createElementVNode("div", _hoisted_67, [_createElementVNode("div", {
    class: "cumulative-recharge-list",
    style: _normalizeStyle({
      width: $setup.progressWidth + 'px'
    })
  }, [_createElementVNode("div", {
    class: "begin",
    id: "begin-icon",
    style: _normalizeStyle({
      width: $setup.longW + 'px'
    })
  }, null, 4), _createElementVNode("div", {
    class: "begging-line",
    style: _normalizeStyle({
      left: $setup.dottedLeft + 'px',
      width: $setup.dottedW + 'px'
    })
  }, [_createElementVNode("div", {
    class: "line",
    style: _normalizeStyle({
      width: $setup.dottedW + 'px',
      'border-top-width': $setup.dottedW > 0 ? '2px' : 0
    })
  }, null, 4)], 4), _cache[62] || (_cache[62] = _createElementVNode("div", {
    class: "recharge-bgc-line"
  }, null, -1)), _createElementVNode("div", {
    class: _normalizeClass(["recharge-block-icon-list", [$setup.progressWidth == 712 ? 'recharge-block-icon-list-sec' : '']]),
    id: "recharge-icon-list"
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.rechargeCategoryList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "recharge-icon-body",
      key: index
    }, [_createElementVNode("div", {
      class: "recharge-icon-img",
      id: `recharge-icon-${index}`
    }, [item.is_rewards != 1 && $setup.rechargePhase != index ? (_openBlock(), _createElementBlock("div", _hoisted_69)) : _createCommentVNode("", true), item.is_rewards == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_70)) : _createCommentVNode("", true), item.is_rewards != 1 && $setup.rechargePhase == index ? (_openBlock(), _createElementBlock("div", _hoisted_71)) : _createCommentVNode("", true)], 8, _hoisted_68)]);
  }), 128))], 2)], 4)])]), $setup.rechargeCategoryList.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_72, [$setup.rechargeCategoryList[$setup.rechargePhase].is_rewards != 1 ? (_openBlock(), _createElementBlock("div", _hoisted_73, [_createTextVNode(" 本次活动已充值" + _toDisplayString($setup.amountPaid) + "元，再充值", 1), _createElementVNode("span", null, _toDisplayString($setup.distanceAmount) + "元", 1), _cache[63] || (_cache[63] = _createTextVNode("即可领取下阶段奖励 "))])) : (_openBlock(), _createElementBlock("div", _hoisted_74, "当前累充活动所有阶段已全部完成"))])) : _createCommentVNode("", true), _createElementVNode("div", {
    class: "bot-tips-detail",
    innerHTML: $setup.rechargeTitle
  }, null, 8, _hoisted_75)])])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_76, [_cache[65] || (_cache[65] = _createElementVNode("div", {
    class: "ruler-title"
  }, "充值说明", -1)), $setup.list.ad_datail ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "tips",
    innerHTML: $setup.list.ad_datail
  }, null, 8, _hoisted_77)) : _createCommentVNode("", true), $setup.list.activity_detail ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "tips",
    innerHTML: $setup.list.activity_detail
  }, null, 8, _hoisted_78)) : _createCommentVNode("", true), $setup.list.rebate_detail ? (_openBlock(), _createElementBlock("div", {
    key: 2,
    class: "tips",
    innerHTML: $setup.list.rebate_detail
  }, null, 8, _hoisted_79)) : _createCommentVNode("", true), _createElementVNode("div", {
    class: "tips",
    innerHTML: $setup.list.product_detail
  }, null, 8, _hoisted_80)])]), $setup.list.category_related_game && $setup.list.category_related_game.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_81, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.list.category_related_game, item => {
    return _openBlock(), _createElementBlock("div", {
      class: "h5-other-list",
      key: item.id
    }, [_createElementVNode("div", _hoisted_82, [_cache[66] || (_cache[66] = _createElementVNode("span", {
      class: "left-line-bgc"
    }, null, -1)), _createElementVNode("span", _hoisted_83, _toDisplayString(item.category_official.name), 1)]), _createElementVNode("div", _hoisted_84, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.game_pay_official_prop, (subItem, subIndex) => {
      return _openBlock(), _createElementBlock("div", {
        class: "pay-block",
        key: subItem.id
      }, [_createElementVNode("div", {
        class: _normalizeClass(["game-pack", [$setup.choiceItem.id == subItem.id ? 'show-pack-icon' : '']]),
        onClick: $event => $setup.choicePay(subItem, subIndex, 2)
      }, [subItem.tag_img ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["discount-icon", [subItem.game_stock == subItem.quantity && subItem.quantity >= 0 ? ' sale-out' : '']])
      }, [_createElementVNode("img", {
        src: subItem.tag_img,
        alt: ""
      }, null, 8, _hoisted_86)], 2)) : _createCommentVNode("", true), _createElementVNode("div", {
        class: _normalizeClass(["tips-list", [subItem.game_stock == subItem.quantity && subItem.quantity >= 0 ? ' sale-out' : '']])
      }, [(subItem.limit_type == 1 || subItem.limit_type == 2 || subItem.limit_type == 3) && subItem.limit_shelve == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_87, [_cache[67] || (_cache[67] = _createTextVNode(" 每")), subItem.limit_type == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_88, "天")) : _createCommentVNode("", true), subItem.limit_type == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_89, "周")) : _createCommentVNode("", true), subItem.limit_type == 3 ? (_openBlock(), _createElementBlock("span", _hoisted_90, "月")) : _createCommentVNode("", true), _createTextVNode("限购" + _toDisplayString(subItem.game_stock) + "/" + _toDisplayString(subItem.quantity), 1)])) : _createCommentVNode("", true), (subItem.limit_type == 1 || subItem.limit_type == 2 || subItem.limit_type == 3) && subItem.limit_shelve > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_91, " 限购" + _toDisplayString(subItem.game_stock) + "/" + _toDisplayString(subItem.quantity), 1)) : _createCommentVNode("", true), subItem.limit_type == 5 ? (_openBlock(), _createElementBlock("div", _hoisted_92, [subItem.is_limited_time != 1 ? (_openBlock(), _createElementBlock("span", _hoisted_93, "永久")) : _createCommentVNode("", true), _cache[68] || (_cache[68] = _createTextVNode("限购")), subItem.quantity > -1 ? (_openBlock(), _createElementBlock("span", _hoisted_94, _toDisplayString(subItem.game_stock) + "/" + _toDisplayString(subItem.quantity), 1)) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _cache[69] || (_cache[69] = _createElementVNode("div", {
        class: "bot-icon"
      }, null, -1))], 2), _createElementVNode("div", _hoisted_95, [subItem.game_stock == subItem.quantity && subItem.quantity >= 0 ? (_openBlock(), _createElementBlock("div", _hoisted_96)) : _createCommentVNode("", true), _createElementVNode("img", {
        class: _normalizeClass([subItem.game_stock == subItem.quantity && subItem.quantity >= 0 ? ' sale-out' : '']),
        src: subItem.image_url,
        alt: ""
      }, null, 10, _hoisted_97), _createElementVNode("div", _hoisted_98, [subItem.is_limited_time == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_99)) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_100, _toDisplayString(subItem.name), 1), _createElementVNode("div", _hoisted_101, "￥" + _toDisplayString(subItem.price), 1)], 10, _hoisted_85)]);
    }), 128))])]);
  }), 128))])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_102, [_cache[81] || (_cache[81] = _createElementVNode("div", {
    class: "title"
  }, "所选商品", -1)), _createElementVNode("div", _hoisted_103, _toDisplayString($setup.choiceItem.name), 1), _createElementVNode("div", _hoisted_104, [_createElementVNode("div", _hoisted_105, [_cache[70] || (_cache[70] = _createElementVNode("div", {
    class: "detail-left"
  }, "含", -1)), $setup.channelType == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_106, _toDisplayString($setup.choiceItem.name) + " " + _toDisplayString($setup.choiceItem.remark), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_107, _toDisplayString($setup.choiceItem.describe), 1))]), $setup.choiceItem.bonus ? (_openBlock(), _createElementBlock("div", _hoisted_108, [_cache[71] || (_cache[71] = _createElementVNode("div", {
    class: "detail-left"
  }, "赠", -1)), _createElementVNode("div", _hoisted_109, _toDisplayString($setup.choiceItem.bonus), 1)])) : _createCommentVNode("", true), _createElementVNode("div", {
    class: _normalizeClass(["detail-list", [$setup.choiceItem.rebate ? '' : 'none-bot']])
  }, [_cache[72] || (_cache[72] = _createElementVNode("div", {
    class: "detail-left detail-left-sec"
  }, "积", -1)), $setup.channelType == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_110, _toDisplayString($setup.choiceItem.price) + "积分 ", 1)) : (_openBlock(), _createElementBlock("div", _hoisted_111, _toDisplayString($setup.choiceItem.points) + "积分 ", 1))], 2), $setup.choiceItem.rebate_num ? (_openBlock(), _createElementBlock("div", _hoisted_112, [_cache[73] || (_cache[73] = _createElementVNode("div", {
    class: "detail-left detail-left-thr"
  }, "返", -1)), _createElementVNode("div", _hoisted_113, [_createTextVNode(_toDisplayString($setup.choiceItem.rebate), 1), $setup.choiceItem.rebate_num > 0 ? (_openBlock(), _createElementBlock("span", _hoisted_114, "(剩余" + _toDisplayString($setup.choiceItem.rebate_num) + "次)", 1)) : _createCommentVNode("", true)])])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_115, [_cache[74] || (_cache[74] = _createTextVNode(" 合计：")), _createElementVNode("span", null, "￥" + _toDisplayString($setup.choiceItem.price) + "元", 1)]), _createElementVNode("div", _hoisted_116, [$setup.showAliPay ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: _normalizeClass(["pay-choice-btn", [$setup.payType == 'alipay' ? ' choice-pay-type' : '']]),
    onClick: _cache[13] || (_cache[13] = $event => $setup.changePay('alipay'))
  }, _cache[75] || (_cache[75] = [_createElementVNode("div", {
    class: "alipay"
  }, [_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })], -1), _createElementVNode("div", {
    class: "pay-mid-title"
  }, "支付宝支付", -1), _createElementVNode("div", {
    class: "pay-recommend"
  }, "推荐", -1)]), 2)) : _createCommentVNode("", true), _createElementVNode("div", {
    class: _normalizeClass(["pay-choice-btn", [$setup.payType == 'wechat' ? ' choice-pay-type' : '']]),
    onClick: _cache[14] || (_cache[14] = $event => $setup.changePay('wechat'))
  }, _cache[76] || (_cache[76] = [_createElementVNode("div", {
    class: "wechat"
  }, [_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  })], -1), _createElementVNode("div", {
    class: "pay-mid-title"
  }, "微信支付", -1)]), 2), _createElementVNode("div", {
    class: _normalizeClass(["pay-choice-btn", [$setup.payType == 'pay_behalf ' ? ' choice-pay-type' : '']]),
    onClick: _cache[15] || (_cache[15] = $event => $setup.changePay('pay_behalf '))
  }, _cache[77] || (_cache[77] = [_createElementVNode("div", {
    class: "wechat"
  }, [_createElementVNode("img", {
    src: _imports_2,
    alt: ""
  })], -1), _createElementVNode("div", {
    class: "pay-mid-title"
  }, "找朋友帮忙付", -1)]), 2), _cache[78] || (_cache[78] = _createElementVNode("div", {
    class: "pay-tips"
  }, " 在进行支付时，由于支付渠道相关规则，可能出现超额提醒、限额提醒、风险提醒等，可切换支付方式后再次尝试 ", -1))]), _createElementVNode("div", _hoisted_117, [_createElementVNode("div", _hoisted_118, [_createVNode(_component_van_button, {
    onClick: _cache[16] || (_cache[16] = $event => $setup.setPay())
  }, {
    default: _withCtx(() => _cache[79] || (_cache[79] = [_createTextVNode("立即支付")])),
    _: 1
  })]), _createElementVNode("div", _hoisted_119, [_cache[80] || (_cache[80] = _createTextVNode(" 温馨提示：请您知悉，点击立即支付即视为您同意")), _createElementVNode("span", {
    onClick: _cache[17] || (_cache[17] = $event => $setup.goRuler())
  }, "《青瓷游戏用户服务协议》")])])]), $setup.rechargeCategoryList.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_120, [_cache[86] || (_cache[86] = _createElementVNode("div", {
    class: "left-line"
  }, [_createElementVNode("span", {
    class: "left-line-bgc"
  }), _createElementVNode("span", {
    class: "left-title"
  }, " 充值活动 ")], -1)), _createElementVNode("div", _hoisted_121, [_createElementVNode("div", _hoisted_122, [_createElementVNode("div", {
    class: _normalizeClass(["recharge-list", [$setup.progressWidth == $setup.rechargeBodyWidth ? 'recharge-list-sec' : '']])
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.rechargeCategoryList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "recharge-block-list",
      key: index
    }, [_createElementVNode("div", {
      class: _normalizeClass([[$setup.rechargePhase == index && !item.is_rewards ? 'recharge-block-sec' : 'recharge-block'], "recharge-public"])
    }, [!item.is_rewards ? (_openBlock(), _createElementBlock("div", _hoisted_123, " 累计" + _toDisplayString(item.price) + "元 ", 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_124, [_createElementVNode("div", _hoisted_125, [_createElementVNode("img", {
      src: item.img || `https://download4.qcplay.com/qcgame-admin/ug1Q1ZRFe6i1Ef7ANtqtB9Bs43HK7cxyITNtUkwH.png`,
      alt: ""
    }, null, 8, _hoisted_126)]), !item.is_rewards ? (_openBlock(), _createElementBlock("div", _hoisted_127, _toDisplayString(item.name), 1)) : _createCommentVNode("", true)]), $setup.rechargePhase == index && !item.is_rewards ? (_openBlock(), _createElementBlock("div", _hoisted_128, " 下阶段 ")) : _createCommentVNode("", true), item.is_rewards ? (_openBlock(), _createElementBlock("div", _hoisted_129, [_cache[82] || (_cache[82] = _createElementVNode("div", {
      class: "over-top-title"
    }, "已获得", -1)), _cache[83] || (_cache[83] = _createElementVNode("div", {
      class: "over-mid-img"
    }, [_createElementVNode("img", {
      src: "https://download4.qcplay.com/qcgame-api/3d7lL3V9x9MrwKANuMbkhzbSrka0rAXC7FU4wOgd.png",
      alt: ""
    })], -1)), _createElementVNode("div", _hoisted_130, _toDisplayString(item.content), 1)])) : _createCommentVNode("", true)], 2)]);
  }), 128))], 2), _createElementVNode("div", _hoisted_131, [_createElementVNode("div", {
    class: "cumulative-recharge-list",
    style: _normalizeStyle({
      width: $setup.progressWidth + 'px'
    })
  }, [_createElementVNode("div", {
    class: "begin",
    id: "h-begin-icon",
    style: _normalizeStyle({
      width: $setup.hLongW + 'px'
    })
  }, null, 4), _createElementVNode("div", {
    class: "begging-line",
    style: _normalizeStyle({
      left: $setup.dottedLeft + 'px',
      width: $setup.dottedW + 'px'
    })
  }, [_createElementVNode("div", {
    class: "line",
    style: _normalizeStyle({
      width: $setup.dottedW + 'px',
      'border-top-width': $setup.dottedW > 0 ? '2px' : 0
    })
  }, null, 4)], 4), _cache[84] || (_cache[84] = _createElementVNode("div", {
    class: "recharge-bgc-line"
  }, null, -1)), _createElementVNode("div", {
    class: _normalizeClass(["recharge-block-icon-list", [$setup.progressWidth == $setup.rechargeBodyWidth ? 'recharge-block-icon-list-sec' : '']]),
    id: "hrecharge-icon-list"
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.rechargeCategoryList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "recharge-icon-body",
      key: index
    }, [_createElementVNode("div", {
      class: "recharge-icon-img",
      id: `hrecharge-icon-${index}`
    }, [item.is_rewards != 1 && $setup.rechargePhase != index ? (_openBlock(), _createElementBlock("div", _hoisted_133)) : _createCommentVNode("", true), item.is_rewards == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_134)) : _createCommentVNode("", true), item.is_rewards != 1 && $setup.rechargePhase == index ? (_openBlock(), _createElementBlock("div", _hoisted_135)) : _createCommentVNode("", true)], 8, _hoisted_132)]);
  }), 128))], 2)], 4)])]), $setup.rechargeCategoryList.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_136, [$setup.rechargeCategoryList[$setup.rechargePhase].is_rewards != 1 ? (_openBlock(), _createElementBlock("div", _hoisted_137, [_createTextVNode(" 本次活动已充值" + _toDisplayString($setup.amountPaid) + "元，再充值", 1), _createElementVNode("span", null, _toDisplayString($setup.distanceAmount) + "元", 1), _cache[85] || (_cache[85] = _createTextVNode("即可领取下阶段奖励 "))])) : (_openBlock(), _createElementBlock("div", _hoisted_138, "当前累充活动所有阶段已全部完成"))])) : _createCommentVNode("", true), _createElementVNode("div", {
    class: "bot-tips-detail",
    innerHTML: $setup.rechargeTitle
  }, null, 8, _hoisted_139)])])) : _createCommentVNode("", true)])])) : (_openBlock(), _createElementBlock("div", _hoisted_140, [_createVNode(_component_PointsMallOld, {
    gameId: $setup.gameId,
    role_id: $setup.role_id,
    onShowGameRole: $setup.showGameRole
  }, null, 8, ["gameId", "role_id", "onShowGameRole"])])), $setup.showCashCoupon ? (_openBlock(), _createElementBlock("div", _hoisted_141, [_cache[87] || (_cache[87] = _createElementVNode("div", {
    class: "ruler-title"
  }, "充值说明", -1)), $setup.list.ad_datail ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "tips",
    innerHTML: $setup.list.ad_datail
  }, null, 8, _hoisted_142)) : _createCommentVNode("", true), $setup.list.activity_detail ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "tips",
    innerHTML: $setup.list.activity_detail
  }, null, 8, _hoisted_143)) : _createCommentVNode("", true), $setup.list.rebate_detail ? (_openBlock(), _createElementBlock("div", {
    key: 2,
    class: "tips",
    innerHTML: $setup.list.rebate_detail
  }, null, 8, _hoisted_144)) : _createCommentVNode("", true), _createElementVNode("div", {
    class: "tips",
    innerHTML: $setup.list.product_detail
  }, null, 8, _hoisted_145)])) : _createCommentVNode("", true), $setup.showCashCoupon ? (_openBlock(), _createElementBlock("div", _hoisted_146, [_createElementVNode("div", _hoisted_147, [_cache[88] || (_cache[88] = _createTextVNode(" 合计：")), _createElementVNode("span", null, "￥" + _toDisplayString($setup.choiceItem.price) + "元", 1)]), _createElementVNode("div", {
    class: "pay-btn",
    onClick: _cache[18] || (_cache[18] = $event => $setup.showH5Pay())
  }, "立即支付")])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_148, [_createElementVNode("div", _hoisted_149, [_createVNode(_component_van_button, {
    onClick: _cache[19] || (_cache[19] = $event => $setup.setPay())
  }, {
    default: _withCtx(() => _cache[89] || (_cache[89] = [_createTextVNode("立即支付")])),
    _: 1
  })]), _createElementVNode("div", _hoisted_150, [_cache[90] || (_cache[90] = _createTextVNode(" 温馨提示：请您知悉，点击立即支付即视为您同意")), _cache[91] || (_cache[91] = _createElementVNode("br", null, null, -1)), _createElementVNode("span", {
    onClick: _cache[20] || (_cache[20] = $event => $setup.goRuler())
  }, "《青瓷游戏用户服务协议》")])])]), _cache[115] || (_cache[115] = _createElementVNode("div", {
    id: "aliPayBtn"
  }, null, -1)), _createVNode(_component_van_popup, {
    show: $setup.showH5PayPopup,
    "onUpdate:show": _cache[27] || (_cache[27] = $event => $setup.showH5PayPopup = $event),
    position: "bottom"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_151, [_createElementVNode("div", _hoisted_152, [_createElementVNode("div", _hoisted_153, _toDisplayString($setup.choiceItem.name), 1), _createVNode(_component_van_icon, {
      name: "cross",
      size: "20",
      onClick: _cache[21] || (_cache[21] = $event => $setup.showH5PayPopup = false)
    })]), _createElementVNode("div", _hoisted_154, [_createElementVNode("div", _hoisted_155, [_cache[92] || (_cache[92] = _createElementVNode("div", {
      class: "detail-left"
    }, "含", -1)), $setup.channelType == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_156, _toDisplayString($setup.choiceItem.name) + " " + _toDisplayString($setup.choiceItem.remark), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_157, _toDisplayString($setup.choiceItem.describe), 1))]), $setup.choiceItem.bonus ? (_openBlock(), _createElementBlock("div", _hoisted_158, [_cache[93] || (_cache[93] = _createElementVNode("div", {
      class: "detail-left"
    }, "赠", -1)), _createElementVNode("div", _hoisted_159, _toDisplayString($setup.choiceItem.bonus), 1)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_160, [_cache[94] || (_cache[94] = _createElementVNode("div", {
      class: "detail-left detail-left-sec"
    }, "积", -1)), $setup.channelType == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_161, _toDisplayString($setup.choiceItem.price) + "积分 ", 1)) : (_openBlock(), _createElementBlock("div", _hoisted_162, _toDisplayString($setup.choiceItem.points) + "积分", 1))]), $setup.choiceItem.rebate_num ? (_openBlock(), _createElementBlock("div", _hoisted_163, [_cache[95] || (_cache[95] = _createElementVNode("div", {
      class: "detail-left detail-left-thr"
    }, "返", -1)), _createElementVNode("div", _hoisted_164, [_createTextVNode(_toDisplayString($setup.choiceItem.rebate), 1), $setup.choiceItem.rebate_num > 0 ? (_openBlock(), _createElementBlock("span", _hoisted_165, "(剩余" + _toDisplayString($setup.choiceItem.rebate_num) + "次)", 1)) : _createCommentVNode("", true)])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_166, [_cache[96] || (_cache[96] = _createElementVNode("div", null, "充值账号:", -1)), _createElementVNode("div", null, _toDisplayString($setup.chooseGameList.dist_name || $setup.chooseGameList.role_name) + " . " + _toDisplayString($setup.chooseGameList.nickname || $setup.chooseGameList.server_name), 1)]), _createElementVNode("div", _hoisted_167, [_cache[97] || (_cache[97] = _createTextVNode(" 合计：")), _createElementVNode("span", null, "￥" + _toDisplayString($setup.choiceItem.price) + "元", 1)])]), _createElementVNode("div", _hoisted_168, [_createElementVNode("div", {
      class: _normalizeClass(["pay-choice-btn", [$setup.payType == 'alipay' ? ' choice-pay-type' : '']]),
      onClick: _cache[22] || (_cache[22] = $event => $setup.changePay('alipay'))
    }, [_cache[98] || (_cache[98] = _createElementVNode("div", {
      class: "alipay"
    }, [_createElementVNode("img", {
      src: _imports_0,
      alt: ""
    })], -1)), _cache[99] || (_cache[99] = _createElementVNode("div", {
      class: "pay-mid-title"
    }, "支付宝支付", -1)), $setup.showAliPay ? (_openBlock(), _createElementBlock("div", _hoisted_169, "推荐")) : _createCommentVNode("", true)], 2), _createElementVNode("div", {
      class: _normalizeClass(["pay-choice-btn", [$setup.payType == 'wechat' ? ' choice-pay-type' : '']]),
      onClick: _cache[23] || (_cache[23] = $event => $setup.changePay('wechat'))
    }, _cache[100] || (_cache[100] = [_createElementVNode("div", {
      class: "wechat"
    }, [_createElementVNode("img", {
      src: _imports_1,
      alt: ""
    })], -1), _createElementVNode("div", {
      class: "pay-mid-title"
    }, "微信支付", -1)]), 2), _createElementVNode("div", {
      class: _normalizeClass(["pay-choice-btn", [$setup.payType == 'pay_behalf ' ? ' choice-pay-type' : '']]),
      onClick: _cache[24] || (_cache[24] = $event => $setup.changePay('pay_behalf '))
    }, _cache[101] || (_cache[101] = [_createElementVNode("div", {
      class: "wechat"
    }, [_createElementVNode("img", {
      src: _imports_2,
      alt: ""
    })], -1), _createElementVNode("div", {
      class: "pay-mid-title"
    }, "找朋友帮忙付", -1)]), 2), _cache[102] || (_cache[102] = _createElementVNode("div", {
      class: "pay-tips"
    }, " 在进行支付时，由于支付渠道相关规则，可能出现超额提醒、限额提醒、风险提醒等，可切换支付方式后再次尝试 ", -1))]), _createElementVNode("div", _hoisted_170, [_createElementVNode("div", _hoisted_171, [_createVNode(_component_van_button, {
      onClick: _cache[25] || (_cache[25] = $event => $setup.setPay())
    }, {
      default: _withCtx(() => _cache[103] || (_cache[103] = [_createTextVNode("立即支付")])),
      _: 1
    })]), _createElementVNode("div", _hoisted_172, [_cache[104] || (_cache[104] = _createTextVNode(" 温馨提示：请您知悉，点击立即支付即视为您同意")), _createElementVNode("span", {
      onClick: _cache[26] || (_cache[26] = $event => $setup.goRuler())
    }, "《青瓷游戏用户服务协议》")])])])]),
    _: 1
  }, 8, ["show"]), _createVNode(_component_van_popup, {
    show: $setup.show,
    "onUpdate:show": _cache[35] || (_cache[35] = $event => $setup.show = $event),
    onClosed: _cache[36] || (_cache[36] = $event => $setup.closeRolePopup())
  }, {
    default: _withCtx(() => [_createElementVNode("div", null, [_createElementVNode("div", {
      class: "close-ico",
      onClick: _cache[28] || (_cache[28] = $event => $setup.show = false)
    }, _cache[105] || (_cache[105] = [_createElementVNode("img", {
      src: _imports_3,
      alt: ""
    }, null, -1)])), _createElementVNode("div", _hoisted_173, [_cache[109] || (_cache[109] = _createElementVNode("div", {
      class: "title"
    }, "选择游戏区组", -1)), _createElementVNode("div", _hoisted_174, [$setup.list.is_os == 1 ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: _normalizeClass(["sys-btn", [$setup.sysTem == 'ios' ? 'system-choose' : '']]),
      onClick: _cache[29] || (_cache[29] = $event => $setup.chooseSystem('ios'))
    }, _cache[106] || (_cache[106] = [_createElementVNode("div", {
      class: "sys-icon"
    }, [_createElementVNode("img", {
      src: _imports_4,
      alt: ""
    })], -1), _createElementVNode("div", null, "苹果", -1)]), 2)) : _createCommentVNode("", true), _createElementVNode("div", {
      class: _normalizeClass(["sys-btn", [$setup.sysTem == 'android' ? 'system-choose' : '']]),
      onClick: _cache[30] || (_cache[30] = $event => $setup.chooseSystem('android'))
    }, [$setup.list.is_os == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_175, "安卓/苹果")) : _createCommentVNode("", true), $setup.list.is_os == 1 || $setup.list.is_os == 3 ? (_openBlock(), _createElementBlock("div", _hoisted_176, _cache[107] || (_cache[107] = [_createElementVNode("div", {
      class: "sys-icon"
    }, [_createElementVNode("img", {
      src: _imports_5,
      alt: ""
    })], -1), _createElementVNode("div", null, "安卓", -1)]))) : _createCommentVNode("", true)], 2)]), _withDirectives(_createElementVNode("select", {
      class: "aread-container",
      "onUpdate:modelValue": _cache[31] || (_cache[31] = $event => $setup.chooseArea = $event),
      onChange: _cache[32] || (_cache[32] = $event => $setup.choiceGameDistName($event))
    }, [_cache[108] || (_cache[108] = _createElementVNode("option", {
      disabled: ""
    }, "请选择区服", -1)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.areaList, (item, index) => {
      return _openBlock(), _createElementBlock("option", {
        key: item.role_id,
        value: index
      }, _toDisplayString(item.dist_name) + "-" + _toDisplayString(item.nickname), 9, _hoisted_177);
    }), 128))], 544), [[_vModelSelect, $setup.chooseArea]]), $setup.latelyPayRole.nickname ? (_openBlock(), _createElementBlock("div", _hoisted_178, " 最近充值：" + _toDisplayString($setup.latelyPayRole.dist_name) + "-" + _toDisplayString($setup.latelyPayRole.nickname), 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_179, [_createElementVNode("div", {
      class: "cancle",
      onClick: _cache[33] || (_cache[33] = $event => $setup.show = false)
    }, "取消"), _createElementVNode("div", {
      class: "confirm",
      onClick: _cache[34] || (_cache[34] = $event => $setup.confirmChoose())
    }, "确定")])])])]),
    _: 1
  }, 8, ["show"]), _createVNode(_component_van_popup, {
    show: $setup.showWechatCode,
    "onUpdate:show": _cache[37] || (_cache[37] = $event => $setup.showWechatCode = $event),
    onClosed: _cache[38] || (_cache[38] = $event => $setup.closeQrcode())
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_180, [_createElementVNode("div", _hoisted_181, null, 512), _cache[110] || (_cache[110] = _createElementVNode("div", {
      class: "title"
    }, "请使用微信扫码付款", -1))])]),
    _: 1
  }, 8, ["show"]), _createVNode(_component_van_popup, {
    show: $setup.showWechatAlipay,
    "onUpdate:show": _cache[40] || (_cache[40] = $event => $setup.showWechatAlipay = $event),
    style: {
      width: '100%',
      height: '100%'
    }
  }, {
    default: _withCtx(() => [_createElementVNode("div", {
      class: "wechat-alipay-popup",
      onClick: _cache[39] || (_cache[39] = $event => $setup.showWechatAlipay = false)
    })]),
    _: 1
  }, 8, ["show"]), _createVNode(_component_van_popup, {
    show: $setup.realNamePopup,
    "onUpdate:show": _cache[46] || (_cache[46] = $event => $setup.realNamePopup = $event)
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_182, [_createElementVNode("div", _hoisted_183, [_createElementVNode("div", _hoisted_184, [_createElementVNode("div", {
      class: "close",
      onClick: _cache[41] || (_cache[41] = $event => $setup.realNamePopup = false)
    }), _createElementVNode("div", {
      onClick: _cache[42] || (_cache[42] = $event => _ctx.kfBtn()),
      class: "some-trouble"
    }, "遇到问题？")])]), _createElementVNode("div", _hoisted_185, [_cache[113] || (_cache[113] = _createElementVNode("div", {
      class: "real-name-title"
    }, "实名认证", -1)), _createElementVNode("div", _hoisted_186, [_createElementVNode("div", _hoisted_187, [_withDirectives(_createElementVNode("input", {
      type: "text",
      placeholder: "请输入姓名",
      "onUpdate:modelValue": _cache[43] || (_cache[43] = $event => $setup.userName = $event)
    }, null, 512), [[_vModelText, $setup.userName]]), _cache[111] || (_cache[111] = _createElementVNode("div", {
      class: "input-title"
    }, [_createElementVNode("div", {
      class: "phone"
    })], -1))])]), _createElementVNode("div", _hoisted_188, [_createElementVNode("div", _hoisted_189, [_withDirectives(_createElementVNode("input", {
      type: "text",
      placeholder: "请输入身份证号",
      class: "sec-input",
      "onUpdate:modelValue": _cache[44] || (_cache[44] = $event => $setup.cardIdNum = $event)
    }, null, 512), [[_vModelText, $setup.cardIdNum]]), _cache[112] || (_cache[112] = _createElementVNode("div", {
      class: "input-title"
    }, [_createElementVNode("div", {
      class: "sms"
    })], -1))])]), _createElementVNode("div", _hoisted_190, [_createElementVNode("button", {
      onClick: _cache[45] || (_cache[45] = $event => $setup.updataUserBtn())
    }, "提交认证")]), _cache[114] || (_cache[114] = _createElementVNode("div", {
      class: "real-name-bot-title"
    }, " 根据《关于进一步严格管理切实防止未成年人沉迷网络游戏的通知》《关于防止未成年人沉迷网络游戏工作的通知》等法规要求需要各位玩家进行实名认证。 ", -1))])])]),
    _: 1
  }, 8, ["show"])]);
}